import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { EntrySummaryStatementModel } from '../models/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class StatementsRepository {
  constructor(private apiService: ApiService) {}

  public get(id: number, isShowLoader: boolean = true): Observable<EntrySummaryStatementModel> {
    return this.apiService.get<EntrySummaryStatementModel>(`${environment.url.prefixCustoms}v2/statements/${id}`, null, { isShowLoader });
  }

  public authorized(id: number, pun: string): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/statements/authorized/${id}`, null, {
      params: {
        pun,
      },
    });
  }
}
